export enum MessagesEnum {
  PROMO_CODE_NOT_FOUND = 'No such promotion code',
  PROMO_CODE_ACCEPTED = 'Promo code accepted'
}
